import { remove, set, set_one, set_many, ADD_PENDING, ADD_REQUEST, REMOVE_PENDING, REMOVE_REQUEST } from '@/store/mutation-mixins'

export default {

    ADD_PENDING, ADD_REQUEST, REMOVE_PENDING, REMOVE_REQUEST,

    REMOVE: remove({ from: 'entities' }),
    SET_COUNTS: set({ to: 'counts' }),
    SET_MANY: set_many({ to: 'entities' }),
    SET_ONE: set_one({ to: 'entities' }),

}
